















import Vue from 'vue';
import Component from 'vue-class-component';
import Header from './Header.vue';
import SideMenu from './SideMenu.vue';
import store from '@/store';

@Component({
    components: {
        Header,
        SideMenu
    }
})
export default class Layout extends Vue {
    get getAsideClass() {
        const changed = Object.assign({}, store.state.valueChangedMap,
            store.state.notationChangedMap, store.state.nullFlavorChangedMap);
        return Object.keys(changed).length > 0 ? 'change-detected' : '';
    }
}
